import { render } from "./HelperWarningMessage.vue?vue&type=template&id=628d89e6"
import script from "./HelperWarningMessage.vue?vue&type=script&lang=js"
export * from "./HelperWarningMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__